import DescriptionComponent from "components/DescriptionComponent";
import TableAction from "components/TableAction";

import isoToDate from "utils/isoToDate";
export const tableData = ({ onClick, newRoute }) => [
  {
    header: "actions",
    Component: ({ param }) => <TableAction {...{ param, newRoute, onClick }} />,
  },
  {
    header: "goal",
    Component: ({ param }) => `${param.goal}`,
  },

  {
    header: "question",
    Component: ({ param }) => param.question,
  },
  {
    header: "answer",
    Component: ({ param }) => <DescriptionComponent description={param.answer} />,
  },
  {
    header: "createdAt",
    Component: ({ param }) => isoToDate(param.createdAt),
  },
];
